import { useParams } from 'react-router'

export const useWorkflowIdentification = () => {
  const { uuid, version } = useParams<{ uuid: string; version?: string }>()
  return { uuid, version: version ? parseInt(version, 10) : undefined }
}

export default useWorkflowIdentification
